module.exports = __webpack_public_path__ + "img/inna_krylkova-min.37a4b438.jpg";